<h1 class="strong" mat-dialog-title>
  {{ 'header.createNews' | translate }}
</h1>
<div class="timesheet-settings-dialog-content" mat-dialog-content>
  @if (!isLoadingNews() && !isLoadingOrgUnits() && !isLoadingUser()) {
    <form [formGroup]="newsForm">
      <div class="row">
        <mat-form-field class="textarea width-100" appearance="outline" floatLabel="always" subscriptSizing="dynamic">
          <mat-label>{{ 'default.title' | translate }}</mat-label>
          <textarea class="textarea" matInput formControlName="title"></textarea>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field class="textarea width-100" appearance="outline" floatLabel="always" subscriptSizing="dynamic">
          <mat-label>{{ 'default.description' | translate }}</mat-label>
          <textarea class="textarea" matInput formControlName="description"></textarea>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field class="width-100" appearance="outline" floatLabel="always" subscriptSizing="dynamic">
          <mat-label>{{ 'default.validFrom' | translate }}</mat-label>
          <input [min]="todaysDate" [matDatepicker]="startDate" matInput formControlName="startDate" />
          <mat-datepicker-toggle [for]="startDate" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #startDate [calendarHeaderComponent]="DatepickerHeaderComponent"></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="width-100" appearance="outline" floatLabel="always" subscriptSizing="dynamic">
          <mat-label>{{ 'default.validTo' | translate }}</mat-label>
          <input [matDatepicker]="endDate" [min]="$safeNavigationMigration(newsForm.value?.startDate)" matInput formControlName="endDate" />
          <mat-datepicker-toggle [for]="endDate" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #endDate [calendarHeaderComponent]="DatepickerHeaderComponent"></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="row">
        <app-universal-dropdown
          class="width-100"
          [isRequiredForce]="true"
          [options]="newsTypes | orderBy: 'name'"
          [additionalTranslationString]="'news.types.'"
          [formControl]="newsForm.get('newsType') | formControl"
          label="news.newsType"
          placeholder="news.newsType"
        ></app-universal-dropdown>
      </div>
      @if (newsForm.get('newsType').value === NEWS_TYPES.GROUP_AND_TEAM) {
        <div class="row">
          <app-universal-dropdown
            class="width-100"
            [isRequiredForce]="true"
            [options]="orgUnitsGroups | orderBy"
            [formControl]="newsForm.get('group') | formControl"
            label="employee.form.group"
            placeholder="employee.form.group"
          ></app-universal-dropdown>
          <app-universal-dropdown
            class="width-100"
            [isRequiredForce]="true"
            [options]="orgTeamsForGroup | orderBy"
            [formControl]="newsForm.get('team') | formControl"
            label="employee.form.team"
            placeholder="employee.form.team"
          ></app-universal-dropdown>
        </div>
      } @else if (newsForm.get('newsType').value === NEWS_TYPES.USER_ROLE) {
        <div class="row">
          <app-universal-dropdown
            class="width-100"
            [isRequiredForce]="true"
            [options]="userRoles | orderBy"
            [additionalTranslationString]="'employee.roles.'"
            [formControl]="newsForm.get('userRole') | formControl"
            label="employee.form.role"
            placeholder="employee.form.role"
          ></app-universal-dropdown>
        </div>
      }
    </form>
  } @else {
    <app-loading [loadingMode]="LoadingMode.OVERLAY"></app-loading>
  }
</div>
<div mat-dialog-actions>
  <button class="btn btn-secondary" (click)="closeDialog()">
    {{ 'default.close' | translate }}
  </button>
  <button class="btn btn-primary" [disabled]="isLoadingNews()" (click)="save()">
    {{ 'default.apply' | translate }}
  </button>
</div>
